export default __webpack_public_path__ + "static/media/no-time-off-filter-results.517c393c.svg";